import { gql } from '@apollo/client';

export const MARK_SHARED_STORY_READ = gql`
  mutation markSharedStoryRead($storyId: ID!) {
    markSharedStoryRead(storyId: $storyId)
  }
`;
